import { Tier, TiersService } from '@mc/api'

let tiers: Array<Tier>

export interface ProductsQueryParams {
  discountSlug?: string
  gift?: boolean
  standardPriceDecreaseBucket?: string
}

export const getTiersAsync = async (
  params?: ProductsQueryParams,
  refresh = false,
) => {
  if (!!tiers && !refresh) {
    return tiers
  }
  const response = await TiersService.getCurrentTierCollection({
    deep: true,
    ...params,
  })

  tiers = response.pricingTiers.map((tier) => ({
    ...tier,
    product: {
      ...tier.product,
      displayMonthlyPrice: tier?.product?.monetizedYearPricePerMonth,
      displayMonthlyPriceWithDiscount:
        tier?.product?.monetizedYearPricePerMonthDiscounted,
    },
  }))

  return tiers
}
